import React, { Component } from 'react'
import PaymentSimulationApp from './PaymentSimulationApp'

class MainApp extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="text-center">
              <div className="main-login__header__logo text-center">
                <a href="javascript: void(0);">
                  <img width="149" src="resources/images/Monnify.svg" alt="Monnify" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: '60px' }}>
          <div className="col-md-offset-5 col-md-6 " style={{margin:"auto"}}>
            <PaymentSimulationApp />
          </div>

          {/* <div className="col-md-5">
            <InternetBankingSimulatorApp />
          </div> */}

        </div>
      </div>
    )
  }
}

export default MainApp



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/index.js